import { render, staticRenderFns } from "./study_buy.vue?vue&type=template&id=ff5246dc&scoped=true&"
import script from "./study_buy.vue?vue&type=script&lang=js&"
export * from "./study_buy.vue?vue&type=script&lang=js&"
import style0 from "./study_buy.vue?vue&type=style&index=0&id=ff5246dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5246dc",
  null
  
)

export default component.exports